export default __webpack_public_path__ + "static/SpaceGrotesk-Bold-9ee2fc15497f7869312f358c0525392e.ttf";